import React from 'react';
import { useHistory, useParams } from 'react-router';
import { getQueryParams } from '../helpers/url';
import AssignmentEdit from '../components/Assignment/AssignmentEdit';

const AssignmentEditPage = () => {
  const history = useHistory();
  const { assignmentInstanceId: assignmentInstanceFromParam } = useParams();
  const {
    instructionalPlanId,
    assignmentInstanceId: assignmentInstanceFromQuery,
  } = getQueryParams(history);
  const assignmentInstanceId =
    assignmentInstanceFromParam || assignmentInstanceFromQuery;

  const onGoBack = () => {
    history.goBack();
  };

  return (
    <AssignmentEdit
      assignmentInstanceId={assignmentInstanceId}
      instructionalPlanId={instructionalPlanId}
      onGoBack={onGoBack}
    />
  );
};

export default AssignmentEditPage;
